<template>
  <div class="content Tabs">

    <b-tabs card>

      <b-tab :title="lang.tab_Categories" :title-link-class="textColors" :title-item-class="textColors" active>
        <b-container class="bv-example-row">
          <b-row>
            <b-col sm=3>

              <TreeLibraryComponent :reloadTree="reloadTree" :iscategory="editCategories" class="treecomponent"
                :lang="lang.Tree"></TreeLibraryComponent>
            </b-col>
            <b-col sm="3">
              <div>

                <!-- <p>{{lang.infotext_1}}:</p>
                    <b-img id="image__category" class="category-image" src="" fluid alt="category image"></b-img> -->
              </div><br>

              <b-form-group label="">
                <b-form-radio-group id="radio-group-1" v-model="selected" :options="options"
                  name="radio-options"></b-form-radio-group>
              </b-form-group>


              <div v-show="selected == 'update'">
                <p>{{lang.infotext_2}}.</p>

                <b-form inline>

                  <b-form-input id="input-category-name-update" class="input-category-name-update"
                    :state="inputNameStatus" v-model="categoryNameUpdate" :placeholder="lang.placeholder_Create"
                    aria-describedby="input-category-feedback" :disabled="disabled"></b-form-input>


                  <b-form-invalid-feedback id="input-category-feedback">
                    {{lang.validinfo_3}}
                  </b-form-invalid-feedback>
                  <b-form-text id="input-live-help">{{lang.infotext_2}}:
                    {{selectedTreeLibraryItemObject.category}}</b-form-text>




                </b-form><br>
                <b-form-group id="input-group-libraryType" :label="lang.label_libraryType" label-for="input-2">
                  <b-form-select v-model="libraryTypeUpdate" size="sm" :options="libraryTypes"
                    :disabled="depth > 2 || depth == 1" aria-describedby="input-category-feedback2"
                    :state="selectLibraryTypeStatusUpdate">
                  </b-form-select>
                  <b-form-invalid-feedback id="input-category-feedback2">
                    {{lang.validinfo_2}}
                  </b-form-invalid-feedback>
                  <b-form-text id="input-live-help2"></b-form-text>
                </b-form-group>
                
                <PermissionGroupComponent v-show="globalSettings.advancedPermissions == true && depth == 2"
                  :lang="lang.PermissionGroups"
                  :defaultSettings="{ groups: $store.getters.selectedTreeLibraryItemObject.groups, isId: true, parent: 'categories' }">
                </PermissionGroupComponent>
                <!-- <p>{{lang.infotext_4}}:</p>
                    <b-form-file
                      v-model="file"
                      :state = null
                      :placeholder= lang.placeholder_file
                      drop-placeholder="Drop file here..."
                      class="import-file"
                      accept="image/jpeg, image/png, image/gif, image/svg"
                      size="sm"

                    ></b-form-file> -->
                <!-- <br><br> -->
                <!-- <p>{{lang.infotext_6}}:</p>
                    <b-form-input id="input-category-template-update" class="input-category-template-update" v-model="partNumberTemplateUpdate" :placeholder="lang.placeholder_Template"></b-form-input> -->
                <br>
                <b-button class="btn update-button" size="sm" :variant="variant"
                  @click="updateCategory">{{lang.button_Update}}
                </b-button>
              </div>




              <div v-if="selected == 'new' && blockForSymbols == false">
                <p>{{lang.infotext_5}}:</p>
                <b-form inline>

                  <b-form-input id="input-category-name" class="input-category-name" :state="inputNameStatus"
                    v-model="categoryName" :placeholder="lang.placeholder_Create"
                    aria-describedby="input-category-feedback"></b-form-input>


                  <b-form-invalid-feedback id="input-category-feedback">
                    {{lang.validinfo_1}}
                  </b-form-invalid-feedback>
                  <b-form-text id="input-live-help3">{{lang.infotext_2}}:
                    {{selectedTreeLibraryItemObject.category}}</b-form-text>




                </b-form><br>

                <b-form-group id="input-group-libraryType" :label="lang.label_libraryType" label-for="input-2">
                  <b-form-select v-model="libraryType" size="sm" :options="filterBasicBundle(libraryTypes)"
                    :disabled="depth > 1" aria-describedby="input-category-feedback2" :state="selectLibraryTypeStatus">
                  </b-form-select>

                  <b-form-invalid-feedback id="input-category-feedback2">
                    {{lang.validinfo_2}}
                  </b-form-invalid-feedback>
                  <b-form-text id="input-live-help4"></b-form-text>
                </b-form-group>
                <!-- <p>{{lang.infotext_3}}:</p>
                    <b-form-file
                      v-model="file"
                      :state = null
                      :placeholder= lang.placeholder_file
                      drop-placeholder="Drop file here..."
                      class="import-file"
                      accept="image/jpeg, image/png, image/gif, image/svg"
                      size="sm"

                    ></b-form-file> -->
                <!-- <br><br>
                    <p>{{lang.infotext_6}}:</p>
                    <b-form-input id="input-category-template" class="input-category-template" v-model="partNumberTemplate" :placeholder="lang.placeholder_Template"></b-form-input> -->


                <PermissionGroupComponent v-show="globalSettings.advancedPermissions == true && depth == 1"
                  :isDisabled="depth == 1" :lang="lang.PermissionGroups"
                  :defaultSettings="{ groups: basicGroupId, isId: true, parent: 'categories' }">
                </PermissionGroupComponent>




                <br>
                <b-button class="btn create-button" size="sm" :variant="variant"
                  @click="createCategory">{{lang.button_Create}}
                </b-button>
              </div>
              <div v-show="selected == 'new' && blockForSymbols == true">
                <p>{{lang.infotext_13}}</p>
              </div>
              <!-- <hr>
                  <p>{{lang.infotext_7}}</p>
                  <p class="info-template"># - {{lang.infotext_8}}<br>
                  {{lang.infotext_9}}<br>
                  ### - {{lang.infotext_10}}<br><br>
                  $ - {{lang.infotext_11}}<br>
                  {{lang.infotext_9}}<br>
                  $$$ - {{lang.infotext_12}}</p> -->




            </b-col>





          </b-row>


        </b-container>
      </b-tab>

    </b-tabs>



  </div>

</template>
<script>
import { mapGetters } from 'vuex'
import TreeLibraryComponent from "@/components/shared/TreeLibraryComponent";
import PermissionGroupComponent from '@/components/shared/PermissionGroupComponent.vue';


//import FormTableComponent from '@/components/shared/FormTableComponent'

export default {
  name: "Content",
  components: {
    TreeLibraryComponent,
    PermissionGroupComponent

  },
  props:{
    lang: Object,

  },
  data () {
    return {
      selected: 'update',
      options: [
        { text: 'Update category', value: 'update' },
        { text: 'New category', value: 'new' },
        
      ],

      file: null,
      categoriesData: {},
      categoryName:"",
      categoryNameUpdate: "",
      partNumberTemplate: "",
      partNumberTemplateUpdate: this.partNumberTemplate,
      disabled: false,
      inputNameStatus: null,
      libraryTypes: [
        { text: 'Choose...', value: null },
        { text: 'Generic Files based Library', value: 'generic_files' }, 
        { text: 'DECIS / OrCAD Capture', value: 'orcad_symbols' },
        //{ text: 'DEHDL / ConceptHDL', value: 'symbols' },
        { text: 'Allegro / OrCAD Footprints', value: 'orcad_footprints' },
        { text: 'Allegro / OrCAD Padstacks', value: 'orcad_padstacks' },
        { text: 'HDL symbols', value: 'hdl_symbols' },
        //{ text: 'Generic Folders based Library', value: 'pcb' }, 
        
  

      ],
      libraryType: null,
      libraryTypeUpdate: null,
      selectLibraryTypeStatus: null,
      selectLibraryTypeStatusUpdate: null,

      reloadTree: false,
      editCategories: true,
      objectData:{},
      objAlertSuccess: {
         text: this.lang.alert_success_create_category,
          type: "success", //success, danger, warning, info
          time: 5 //sec.

      },
      objAlertError:{
        text:this.lang.alert_error_create_category,
          type: "danger", //success, danger, warning, info
          time: 5 //sec.
      },
      objAlertSuccessUpdate: {
         text: this.lang.alert_success_update_category,
          type: "success", //success, danger, warning, info
          time: 5 //sec.

      },
      objAlertErrorUpdate:{
        text:this.lang.alert_error_update_category,
          type: "danger", //success, danger, warning, info
          time: 5 //sec.
      },
      basicGroupId: []
    }
    
  },
  computed: {
    ...mapGetters({
      appConf: 'appConf',
      formDetailsData: 'formDetailsData',
      elementCategory: 'elementCategory',
      //projectCategoriesData: 'projectCategoriesData',
      selectedTreeLibraryItemObject: 'selectedTreeLibraryItemObject',
      globalSettings: 'globalSettings'
    }),
    categoryId(){
      return this.$store.getters.selectedTreeLibraryItemObject.categoryId
    },
    image(){
      return this.$store.getters.selectedTreeLibraryItemObject.image;
    },
    categoryNameUpdateTree(){
      return this.$store.getters.selectedTreeLibraryItemObject.name;
    },
    partNumberTemplateTree(){
      return this.$store.getters.selectedTreeLibraryItemObject.partNumberTemplate;
    },
    libraryTypeUpdateTree() {
      return this.$store.getters.selectedTreeLibraryItemObject.libraryType;
    },
    depth() {
      return this.$store.getters.selectedTreeLibraryItemObject.depth;
    },
    textColors(){
      if (this.$store.getters.s_skinVariant == "dark"){
        return ['tabs-bg-dark', 'tabs-text-light']
      }else{
        return ['tabs-bg-light', 'tabs-text-dark']
      }

    },
    variant(){
      if (this.$store.getters.s_skinVariant == "dark"){
        return "light";
      }else{
        return "dark";
      }
      
    },
    blockForSymbols() {
      if (this.depth > 2 && (this.libraryTypeUpdate == "orcad_symbols" || this.libraryTypeUpdate == "hdl_symbols")) {
        return true;
      } else {
        return false;
      }
    },
    permissionGroup() {

      return this.$store.getters.permissionGroup
    }

  },
  created() {
    this.getGroups();

    if (this.appConf.status.isHDL == true) {
      
    }

    if (this.$store.getters.selectedTreeLibraryItemObject.name == "All libraries") {
      this.disabled = true;
    } else {
      this.disabled = false;
    }
    this.categoryNameUpdate = this.$store.getters.selectedTreeLibraryItemObject.name;
    this.libraryTypeUpdate = this.$store.getters.selectedTreeLibraryItemObject.libraryType;

    
  },

  updated() {
        
  },
  watch: {
    categoryId: function() {
      
      //this.selectLibraryTypeStatus = null;
      //this.displayImageCategory();
      this.libraryTypeUpdate = this.$store.getters.selectedTreeLibraryItemObject.libraryType;
      
    },
    projectCategoriesData: function(newVal) {
     this.categoriesData = JSON.parse(newVal.data);


    },
    categoryName: function(newVal){
      if (newVal == ""){
        this.inputNameStatus = null;
      }else{
        this.inputNameStatus = true;
      }

      
    },
    categoryNameUpdateTree: function(newVal){
      if (newVal == ""){
        this.inputNameStatus = null;
      }else{
        this.inputNameStatus = true;
      }
      if(newVal == "All libraries"){
        this.disabled = true;
      }else{
        this.disabled = false;
      }
      
      this.categoryNameUpdate = newVal;
    },
    partNumberTemplateTree: function(newVal){
      
      
      this.partNumberTemplateUpdate = newVal;
    },
    libraryTypeUpdateTree: function (newVal) {
      if (newVal == null) {
        this.libraryTypeUpdate = null;
      } else {
        this.libraryTypeUpdate = newVal;
      }


    },
    libraryType: function (newVal) {
      if (newVal == null) {
        this.selectLibraryTypeStatus = false;
      } else {
        this.selectLibraryTypeStatus = true;
      }


    },
    libraryTypeUpdate: function (newVal) {
      if (this.depth == 2 && newVal == null) {
        this.selectLibraryTypeStatusUpdate = false;
      } else {
        this.selectLibraryTypeStatusUpdate = true;
      }


    },
    
  },
  methods: {
    getGroups() {

      let _vue = this;
      this.basicGroupId = [];

      this.$store.dispatch("u_getGroups")
        .then(function (result) {

          console.log(result.data)

          if (result.status == "OK") {

            if (result.data != null) {


              for (let i = 0, lei = result.data.length; i < lei; i++) {
                if (result.data[i].groupName == "All") {
                  _vue.basicGroupId.push(result.data[i].groupId);
                }
                if (result.data[i].groupName == "Admins") {
                  //_vue.basicGroupId.push(result.data[i].groupId);
                }

              }
            }
          }




        })
    },
    assignItemToGroup(categoryId) {
      let vue = this;
      

      let groups = []
      for (let i = 0, lei = this.permissionGroup.length; i < lei; i++){
        groups.push(this.permissionGroup[i].groupId)
      }

      let obj = {
        objectId: categoryId,
        type: "library category",
        groups: groups
      }

      this.$store.dispatch("u_assignItemToGroup", obj)
        .then((result) => {
          console.log(result.data)

          if (result.status == "OK") {
            if (result.data != null) {


              vue.reloadTree = !vue.reloadTree;


            }
          }
          
        })
    },
    filterBasicBundle(list) {
      let index = -1;
      if (!this.appConf.status.isHDL) {
        for (let i = 0, lei = list.length; i < lei; i++) {
          if (list[i].value == 'hdl_symbols') {
            index = i;
            break;
          }
        }
      }
      if (index > -1) {
        list.splice(index, 1);
      }

      return list;
    },
    // displayImageCategory(image = this.image){

    //   if (image != undefined){
    //     let vue = this;

    //     const obj = {
    //       fileName: image
    //     }
        

        
    //     this.$store.dispatch("getImage", obj)
    //     .then((result) => {
    //       console.log(result)
          
            
    //         vue.$nextTick(function () {

    //           let img = document.getElementById("image__category");
              
    //           img.src = "";
    //           img.src = URL.createObjectURL(result);
              

              
    //         })
            
            
        
        
    //     })


    //   }
      

    // },
    createCategory() {
      
      if (this.depth == 1 && this.libraryType == null) {
        
        this.selectLibraryTypeStatus = false;
        return
      }
      
      if (this.categoryName != ""){

        let file = "";
        
        if (this.file != null){
          
          file = this.file;
        }
        let obj = {
          parentId: this.selectedTreeLibraryItemObject.categoryId,
          fullPath: this.selectedTreeLibraryItemObject.category + "\\" + this.categoryName,
          //objAlertSuccess: this.objAlertSuccess,
          //objAlertError: this.objAlertError,
          file: file,
          template: this.partNumberTemplate,
          libraryType: this.libraryType
        }
        
        let vue = this;
        this.$store.dispatch(this.$store.getters.sectionPrefix + "_createCategory", obj)
           .then((result)=>{
             console.log(result.data)

             if (result.status == "OK") {
               if (result.data != null) {


                 vue.categoryName = "";
                 vue.inputStatus = null;

                 let categoryId = result.data;

                 vue.assignItemToGroup(categoryId);


                 vue.reloadTree = !vue.reloadTree;

                 const obj = {
                   text: vue.lang.alert_success_create_category,
                   time: 10,
                   type: "success"
                 }

                 vue.$store.dispatch("displayFooterAlert", obj);
               } else {
                 const obj = {
                   text: vue.lang.alert_error_create_category + ": " + result.message,
                   time: 15,
                   type: "success"
                 }

                 vue.$store.dispatch("displayFooterAlert", obj);
               }
             } else {
               const obj = {
                 text: vue.lang.alert_error_create_category + ": " + result.message,
                 time: 15,
                 type: "danger"
               }

               vue.$store.dispatch("displayFooterAlert", obj);
             }

              // if(result.data != null){

              //   vue.categoryName = "";
              //   vue.inputNameStatus = null;

              //   let categoryId = result.data;

              //   vue.assignItemToGroup(categoryId);

              //   //vue.reloadTree= !vue.reloadTree;
              // }
        })


      }else{

      }

    },
    
    updateCategory() {

      if (this.depth == 1) {

        
        return
      }
      if (this.depth == 2 && this.libraryTypeUpdate == null) {
        
        this.selectLibraryTypeStatusUpdate = false;
        return
      }
      if (this.categoryNameUpdate != ""){

        let file = "";
        
        if (this.file != null){
          
          file = this.file;
        }

        let path = this.selectedTreeLibraryItemObject.category;
        let temp = path.split("\\")
        

        let lei = temp.length;
        temp[lei - 1] = this.categoryNameUpdate
        

        let newPath = "";
        for(let i = 0; i < lei; i++ ){
          newPath += temp[i];
          if (i < lei - 1){
            newPath += "\\";
          }
        }

        let categoryId = this.selectedTreeLibraryItemObject.categoryId;

        let obj = {
          categoryId: categoryId,
          fullPath: newPath,
          //objAlertSuccess: this.objAlertSuccessUpdate,
          //objAlertError: this.objAlertErrorUpdate,
          file: file,
          template: this.partNumberTemplateUpdate,
          libraryType: this.libraryTypeUpdate
        }
        
        let vue = this;
        this.$store.dispatch(this.$store.getters.sectionPrefix + "_updateCategory", obj)
           .then((result)=>{
             console.log(result.data)

             if (result.status == "OK") {
               if (result.data == 1) {


                 vue.assignItemToGroup(categoryId);

                 const obj = {
                   text: vue.lang.alert_success_update_category,
                   time: 10,
                   type: "success"
                 }

                 vue.$store.dispatch("displayFooterAlert", obj);
               } else {
                 const obj = {
                   text: vue.lang.alert_error_update_category + ": " + result.message,
                   time: 15,
                   type: "success"
                 }

                 vue.$store.dispatch("displayFooterAlert", obj);
               }
             } else {
               const obj = {
                 text: vue.lang.alert_error_update_category + ": " + result.message,
                 time: 15,
                 type: "danger"
               }

               vue.$store.dispatch("displayFooterAlert", obj);
             }
              
              // if(result.data != null){

              //   vue.assignItemToGroup(categoryId);
                

                

              //   //vue.displayImageCategory(result.data.fileId);
              // }
        })


      }else{

      }
    }

  },
  
}
</script>

<style scooped>
.bv-example-row-max{
    max-width: 100%;
    padding-right: 0px;
    padding-left: 0px;
  }

  .content .btn{
    margin-left: 5px;

  }
  .content .input-category-name{
     width: 300px;
  }
  .content .input-category-name-update{
     width: 300px;
  }
  .img-fluid {
    max-width: 200px;
    
  }
  .category-image{
    max-width: 200px;
  } 
  

  .info-template{
    width: 600px;
  }
    .custom-select-sm {
      height: 26px;
      padding-top: 0.05rem;
      
    }
</style>



// WEBPACK FOOTER //
// src/components/LibraryManager/Views/Categories/Middle/Content/Content.vue